import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-flex-direction-column" }
const _hoisted_2 = { class: "is-flex is-flex-direction-column mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", null, "Id", -1)
const _hoisted_4 = { class: "is-flex is-flex-direction-column" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column mb-4 mr-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Verticais", -1)
const _hoisted_7 = ["value", "max"]
const _hoisted_8 = { class: "is-flex is-flex-direction-column mb-4 mr-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " Contextos ", -1)
const _hoisted_10 = ["value", "max"]

import ILicenca from '@/interfaces/ILicenca';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DetalheLicenca',
  props: {
    licenca: {},
    ultimoObjeto: {}
  },
  setup(__props: any) {

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_ctx.ultimoObjeto.id), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("progress", {
          class: "progress is-primary is-medium",
          value: _ctx.ultimoObjeto?.totalVertical,
          max: _ctx.licenca?.verticais
        }, null, 8, _hoisted_7),
        _createElementVNode("small", null, " Em uso: " + _toDisplayString(_ctx.ultimoObjeto?.totalVertical) + " / " + _toDisplayString(_ctx.licenca?.verticais), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("progress", {
          class: "progress is-primary is-medium",
          value: _ctx.ultimoObjeto?.totalContexto,
          max: _ctx.licenca?.contextoExecucao
        }, null, 8, _hoisted_10),
        _createElementVNode("small", null, " Em uso: " + _toDisplayString(_ctx.ultimoObjeto?.totalContexto) + " / " + _toDisplayString(_ctx.licenca?.contextoExecucao), 1)
      ])
    ])
  ]))
}
}

})